export const environment = {
  env: 'sit',
  sURL: 'https://sit-api.sadmincontrol.com/v1/api/',
  bURL: 'https://sit-api.sadmincontrol.com',
  mURL: 'https://sit-market.sadmincontrol.com',
  enableSetRCsubaccount: true,
  enableDashboard: true,
  firstIndexPnl: false,
  riskCalculatorURL: 'https://sit-market.sadmincontrol.com/risk_calculator',
  betTickerURL:'https://sit-betticker',
  betTickerV1URL:'https://sit-betticker-v1',
  pspAdminURL:'https://sit-psp-admin.freedemokit.com',
  kjsport9URL:'https://kjs-back.pkrsrv.com/webadmin-VDX0Xj',
  casinoApiBaseUrl: 'https://sit-casino.sadmincontrol.com',
  shivajiexchangeAdminURL:'https://sit-admin.shivajiexchange.com',
  FARO_URL: 'https://sit-faro.sadmincontrol.com/collect',
  OTEL_ENABLED: true,
  // sit-api does not allow traceparent in CORS headers (old image, pre-PNIX-1841).
  // Re-add /^https:\/\/sit-api\.sadmincontrol\.com\// once sit branch is updated.
  tracePropagationTargets: [/^http:\/\/localhost/],
};
